import * as DetailActions from './Detail';
import * as PageActions from './Page';
import * as DataQueryActions from './DataQuery';
import * as FindingActions from './Findings';
import * as MessageActions from './Message';
import * as UserActions from './Users';

export const Detail = DetailActions;
export const Page = PageActions;
export const DataQuery = DataQueryActions;
export const Findings = FindingActions;
export const User = UserActions;

const actions = {
  Detail: DetailActions,
  Page: PageActions,
  DataQuery: DataQueryActions,
  Finding: FindingActions,
  Message: MessageActions,
  User: UserActions,
};

export default actions;



// WEBPACK FOOTER //
// ./src/redux/actions/index.js